import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import AbstractCommand from '../AbstractCommand';
import Signals from '../../signals/Signals';

import invoiceConceptUnarchive from '../../requests/invoiceConceptUnarchive';
import InvoiceConceptStatus from '../../data/InvoiceConceptStatus';

/**
 *
 */
export default class UnarchiveInvoiceConceptCommand extends AbstractCommand {

	/**
	 *
	 * @param invoiceConceptModel InvoiceConceptModel
	 * @param company Company
	 */
	constructor(invoiceConceptModel, company) {
		super();

		this.invoiceConceptModel = invoiceConceptModel;
		this.company = company;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return invoiceConceptUnarchive(this.company.id, this.invoiceConceptModel.id)
			.then((response) => {

				this.invoiceConceptModel.status = InvoiceConceptStatus.PAID;
				this._showSuccessMessage();

				if(success) {
					success(response);
				}
			})
			.catch((err) => {

				Signals.Error.dispatch(err);

				if(error) {
					error(err);
				}
			});
	}

	/**
	 *
	 * @private
	 */
	_showSuccessMessage() {
		// Show message
		Signals.ShowMessageDialog.dispatch(
			(<FormattedHTMLMessage id="invoice.unarchived.message"
								   values={{invoiceNr: this.invoiceConceptModel.invoiceNr}}/>)
		);
	}
}
